<template>
  <div id="location">
    <div class="container_location">
      <svg xmlns="http://www.w3.org/2000/svg" id="圖層_1" enable-background="new 0 0 640 480" viewBox="0 0 640 480" x="0px" y="0px" xmlns:xml="http://www.w3.org/XML/1998/namespace" xml:space="preserve" version="1.0">
      <path id="Shengang-Township" @click="showAlert1" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 331.2 41.3 l 6.4 -8.7 l 1.6 -0.3 l 4 -5.5 l 2.5 -2.2 l 3.8 -7.3 l 0.9 -2.5 l 2.3 -3.4 l 1.3 0.3 l 0.5 -1.7 l 18.9 7 l 2.7 3.2 l 1.1 1.3 l 3.1 7.3 l 3.2 8.8 l 3.3 8.3 l 2.2 4.3 l -3.8 1.7 l -0.4 0.3 l -0.8 1 l -4.7 0 l -1.3 6.9 l 0.6 0.5 l -6 0.5 l -2.4 0.9 l 0 1 l 1.3 1.6 l 3.9 0.5 l -0.3 3.4 l -1.3 4.5 l -1.4 6.9 l -2.1 3.1 l -2.4 -1.4 l -4.5 -1.8 l -4.8 -2.3 l -2.6 -1 l -1.1 -3.8 l -2.2 -1.2 l -2 2.4 l -5.5 -1.3 l -2 -1.5 l -0.5 1.8 l -6 -1.8 l -0.1 -1.1 l -2.1 -2.7 l -0.5 -2.4 l -6.8 1.7 l -3.4 -0.6 l -0.2 1.7 l -3.8 -0.8 l -1.1 -1.1 l -11.4 -9.4 l 0.9 -1.2 l -1.4 -1.3 l 0.6 -0.5 l 19.5 -0.1 l 2.2 -1 l 3 -2 l 3.7 -4.8 l -5.4 -2.8 L 331.2 41.3 Z"/>
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="10%" xlink:href="#Shengang-Township" text-anchor="middle">伸港
        </textPath>
      </text>
      <path id="Xianxi-Township" @click="showAlert2" @mouseover="getInfo('Xianxi-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 349.4 104 l -0.1 2.1 l -1.9 1.1 l -0.2 1.7 l -2.2 -0.1 l -2.8 6.4 l -1.7 -1.8 l -4 -1.7 l -2.3 -1.9 l -3 -0.3 l 3.6 -0.9 l -2.1 -4.8 l -1.8 -3.1 l -3.9 -2.8 l -1.8 -0.6 l -0.6 -3 l -4.2 -5 l -8.9 0 l -2.1 1.4 l -5.3 1.3 l -3.1 -1 l -3.7 1.1 L 282 92.3 l 4.2 -10.5 l 2.7 -6.5 l 2.9 -3.5 l 9.2 -11.1 l 2.8 -3.4 l 3 -3.3 l 1.4 1.3 l -0.9 1.2 l 11.4 9.4 l 1.1 1.1 l 3.8 0.8 l 0.2 -1.7 l 3.4 0.6 l 6.8 -1.7 l 0.5 2.4 l 2.1 2.7 l 0.1 1.1 l 6 1.8 l 0.5 -1.8 l 2 1.5 l 5.5 1.3 l -0.3 4.7 l 0.6 6.2 l 0.7 2.1 l 0.2 1.6 l 3.2 4.6 l -1.9 4.5 l -1.3 0.1 L 349.4 104 Z"/>
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10" textLength="300">
        <textPath startOffset="40%" xlink:href="#Xianxi-Township" text-anchor="middle">線西
        </textPath>
      </text>
      <path id="Hemei-Township" @click="showAlert3" @mouseover="getInfo('Hemei-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 400.3 87.4 l 3.3 3 l 6.4 1.8 l 3.1 5.1 l 1.9 3.1 l 4.5 3 l -1.4 3.3 l -0.3 2.4 l -2.1 -0.8 l -1.3 5.8 l -1.5 3.1 l -1.6 0.5 l -0.6 2.5 l 0.8 4.3 l -0.4 0.3 l -4.7 2.3 l -1.9 -0.4 l 0.1 1.7 l -1.2 -0.1 l -1.2 1.1 l -3.6 0.1 l -3.9 0.4 l -1.2 4.3 l -1.5 1.6 l -1.1 0.9 l -3.8 0.2 l -2.9 -2.8 l -2 0 l -0.5 0.8 l 2.1 1.8 l 2.5 4.9 l -0.8 -0.8 l -2.8 -1 l -4.2 -0.4 l -0.4 3.6 l -1.3 0.7 l -2.2 -0.9 l -4.5 0.1 l -1.1 0.4 l -0.8 2 l -2.4 -1.4 l -4.5 0.4 l -0.3 0 l -2.7 -1.9 l -1.1 -1.6 l -1.2 -1.6 l 1.4 -4.8 l -0.6 -3.4 l 1.7 -4.2 l -2.4 -2 l -1.4 -0.2 l -1 -3.7 l -1.3 -1.1 l -2.2 -0.1 l -1.6 0.4 l -1.8 -1.1 l -1.6 -2.9 l 1.7 -0.9 l 0.1 -1.7 l -1.3 -0.6 l 1.4 -2.3 l -0.5 -1.9 l 0.2 -1.7 l 1.9 -1.1 l 0.1 -2.1 l 2.5 -6.1 l 1.3 -0.1 l 1.9 -4.5 l -3.2 -4.6 l -0.2 -1.6 l -0.7 -2.1 l -0.6 -6.2 l 0.3 -4.7 l 2 -2.4 l 2.2 1.2 l 1.1 3.8 l 2.6 1 l 4.8 2.3 l 4.5 1.8 l 2.4 1.4 l 2.1 -3.1 l 1.4 -6.9 l 1.3 -4.5 l 0.3 -3.4 l -3.9 -0.5 l -1.3 -1.6 l 0 -1 l 2.4 -0.9 l 6 -0.5 l -0.6 -0.5 l 1.3 -6.9 l 4.7 0 l 0.8 -1 l 0.4 -0.3 l 3.8 -1.7 l 1.1 3.3 l 1.8 3.4 l 2 3.4 l 1.4 4.3 l -1.1 5.9 l -1.6 2.5 l 0.4 1.7 l 6.3 9.7 L 400.3 87.4 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="88%" xlink:href="#Hemei-Township" text-anchor="middle">和美
        </textPath>
      </text>
      <path id="Zhanghua-City" @click="showAlert4" @mouseover="getInfo('Zhanghua-City')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 436.3 108.1 l 6.8 1.6 l 4.1 -1.4 l 6.8 0.1 l 2.3 2.2 l 3.5 1.6 l 6 1.3 l 5.2 -0.3 l 2.8 2.5 l 5.5 0.2 l 0.9 0.7 l 3.6 -0.5 l 0.1 3.8 l 0.8 1.2 l 0.2 3.1 l 1.5 6 l 0.3 6.4 l 0.7 1.5 l 2.9 8.8 l 1 2.3 l 2.4 0.4 l 2.1 1.3 l 1.4 2.8 l -0.5 2.9 l 0.6 -0.1 l 0.3 10.5 l -2.1 4.2 l -0.1 1.5 l 1.1 4.1 l 1.3 1.7 l -1.9 0.8 l -3.1 0 l -4.3 2.7 l -3.7 0.4 l -5.7 -0.7 l -4.9 1.2 l 0 0.8 l -4.5 2.2 l -1.8 0.1 l -3.7 2.1 l -0.9 -3.9 l -3.3 -2.8 l -1 -0.1 l -1 -2.2 l 1.2 -1.3 l -2.7 -2.8 l -0.4 -1.8 l -1.5 -0.5 l -0.9 -0.2 l -1.2 0.1 l -4 -3.1 l -0.9 1.2 l -3.1 -0.8 l -1.1 -2.3 l -1.9 0 l -1.5 1.2 l -1.8 -0.3 l -3.6 2.1 l -0.7 1.7 l -2.1 0.6 l -3.2 2.4 l -1.9 0 l -0.5 -1 l -1.2 -0.9 l -2.3 0.1 l -2.1 -3.5 l -1.5 -0.8 l -2.9 0.8 l -9.6 -0.5 l -2.2 -0.1 l -1.1 2.9 l -3.9 -0.1 l -7 -0.7 l 0.3 -0.9 l -2.5 -1.1 l -1.5 -2 l -1.7 4.5 l -2.9 -0.6 l -3.7 -2.7 l -4.1 4.2 l -1.1 -1.7 l 1.2 -1.1 l -0.3 -1.7 l -1.8 -1.4 l -1 -3 l 0.3 -1.9 l 2.4 0 l 0 -3.6 l 0 -3.2 l -2.8 -1.9 l -1.1 -2.6 l 0.9 -1.7 l -4 -4 l 0.8 -2 l 1.1 -0.4 l 4.5 -0.1 l 2.2 0.9 l 1.3 -0.7 l 0.4 -3.6 l 4.2 0.4 l 2.8 1 l 0.8 0.8 l -2.5 -4.9 l -2.1 -1.8 l 0.5 -0.8 l 2 0 l 2.9 2.8 l 3.8 -0.2 l 1.1 -0.9 l 1.5 -1.6 l 1.2 -4.3 l 3.9 -0.4 l 3.6 -0.1 l 1.2 -1.1 l 1.2 0.1 l -0.1 -1.7 l 1.9 0.4 l 4.7 -2.3 l 0.4 -0.3 l -0.8 -4.3 l 0.6 -2.5 l 1.6 -0.5 l 1.5 -3.1 l 1.3 -5.8 l 2.1 0.8 l 0.3 -2.4 l 1.4 -3.3 l 4.2 1.2 l 2.6 0.2 l 0 1 l 1.9 -0.8 L 436.3 108.1 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="0%" xlink:href="#Zhanghua-City" text-anchor="middle">彰化市
        </textPath>
      </text>
      <path id="Lugang-Township" @click="showAlert5"  @mouseover="getInfo('Lugang-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 298 172.5 l -0.7 -1.4 l -1.1 -2.3 l -0.7 -0.7 l -3.8 0.8 l -3 2.3 l -2.8 -1.6 l 0 -2 l -1.9 -0.1 l -2.9 -1.9 l -3.7 -1.8 l -3.8 2 l -2.2 0.7 l -9.7 -0.2 l -13 0.2 l -14.6 0.9 l -9.7 1 l -16.5 2.4 l -0.3 -1.9 l -2.5 -4.7 l 2.4 -0.5 l 3.2 -7.4 l 1.3 -2 l 3.7 -3.2 l 4.8 -1.2 l 4.4 -2 l 2 -2.2 l 2.2 -5.1 l 2.3 -0.7 l 5.4 -0.2 l 0.8 -0.4 l 4 -1.1 l 7.1 -3.9 l 1.8 -1.3 l 0.6 -3.3 l 48.4 1 l -1.3 -2.7 l 2.3 -0.3 l 2.2 -1.4 l -0.1 -0.8 l -3 0.2 l -1.3 -1.3 l 3.8 -17.1 l -0.7 -0.7 l 2.2 -8.4 l 0.2 -3 L 284.8 95 l -4.4 18.1 l -1.4 2.1 l -3.8 -0.1 l -5.2 0.6 l -3.7 -1.8 l -5.4 -2.1 l -2.7 3.1 l -5.1 6.7 l 2.1 0.4 l -6.9 0.4 l -2 2.1 l 11.2 -15.7 l 9.9 -14.3 l 1.7 -2.1 l 12.8 -0.1 l 15.1 -0.1 l 3.7 -1.1 l 3.1 1 l 5.3 -1.3 l 2.1 -1.4 l 8.9 0 l 4.2 5 l 0.6 3 l 1.8 0.6 l 3.9 2.8 l 1.8 3.1 l 2.1 4.8 l -3.6 0.9 l 3 0.3 l 2.3 1.9 l 4 1.7 l 1.7 1.8 l 2.8 -6.4 l 2.2 0.1 l 0.5 1.9 l -1.4 2.3 l 1.3 0.6 l -0.1 1.7 l -1.7 0.9 l 1.6 2.9 l 1.8 1.1 l 1.6 -0.4 l 2.2 0.1 l 1.3 1.1 l 1 3.7 l 1.4 0.2 l 2.4 2 l -1.7 4.2 l 0.6 3.4 l -1.4 4.8 l 1.2 1.6 l 1.1 1.6 l 2.7 1.9 l -1.9 3.3 l -1.1 -0.4 l -7.6 2.7 l -2.9 0 l 0.1 1.5 l 2.1 2.9 l 0.1 11.3 l -1 0.6 l -2.3 0.8 l 1.3 3.4 l 0.6 0.8 l -1.3 7.7 l -1.2 -0.6 l -6.1 -1.4 l -2.7 -1.7 l -2 -2.3 l -1.9 0.5 l -2.3 -1 l -10.5 -0.1 l -4.2 -1 l -2.4 -0.5 l -4.8 -0.2 l -1.4 0.8 l -1.8 -0.6 l 1.2 5.1 l 1.9 1.2 l -1.6 2.3 l 3.6 1.8 l 0.4 0.8 l 1.1 1.5 l 0 2.5 l -1.6 -0.2 l -1.1 -2.1 l -1.8 -0.7 l -0.6 -1.7 l -2.2 -1.8 l -3.4 -1.9 L 298 172.5 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="50%" xlink:href="#Lugang-Township" text-anchor="middle">鹿港
        </textPath>
      </text>
      <path id="Fuxing-Township" @click="showAlert6" @mouseover="getInfo('Fuxing-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 348.9 200.9 l 1.9 2.2 l 3.4 2.2 l 3.7 2.1 l 6.8 6 l -1.3 2.7 l -0.3 1.5 l 1.6 -0.7 l 1.7 1.6 l -3.9 1.5 l 1.1 1.3 l 1.3 3.3 l -1.5 -0.4 L 362 222 l -1.7 -1.3 l -6.4 -2.3 l -5.9 -0.6 l -7 -1.3 l -3.7 0 l -5.3 0 l -0.4 0 l -1.5 -0.5 l -5.3 -3.6 l -7.6 -5 l -1.6 -2.6 l -1.6 -0.6 l -1.4 0.6 l -1.1 -1.5 l -1.5 -2 l -0.6 2.9 l -2.5 0.3 l -4 1.1 l -0.3 3.9 l -6.6 5.2 l -1.7 3.7 l 3.1 2.9 l -0.9 4.4 l -2.8 -0.2 l -0.6 5.2 l -2 -0.2 l -0.3 2 l 2 0.2 l -0.6 6 l -6.8 -3.4 l -5.1 -1.1 l -1.6 -0.6 l 0.8 1.6 l -2.4 -2.2 l -1.4 -0.4 l -2.6 -1 l -1.1 -2.8 l -3.4 -1.3 l -2.7 0.5 l -3.7 -1.7 l -1.5 -1.4 l -4.4 -2.3 l 0.7 -3.1 l -2.2 -0.4 l -0.1 -2.7 l -0.7 -0.5 l 0 -2.7 l -2 -1.3 l 0.1 -2.9 l -3.6 -5.9 l -0.4 -1.2 l -2.4 -1.6 l -1.9 -2.4 l -3.5 -8.8 l -2.8 -0.8 l -11.1 -3.6 l -11.6 -4.1 l -7.4 -2.9 l 0.6 -6.6 l 16.5 -2.4 l 9.7 -1 l 14.6 -0.9 l 13 -0.2 l 9.7 0.2 l 2.2 -0.7 l 3.8 -2 l 3.7 1.8 l 2.9 1.9 l 1.9 0.1 l 0 2 l 2.8 1.6 l 3 -2.3 l 3.8 -0.8 l 0.7 0.7 l 1.1 2.3 l 0.7 1.4 l 3.9 5 l 3.4 1.9 l 2.2 1.8 l 0.6 1.7 l 1.8 0.7 l 1.1 2.1 l 1.6 0.2 l 0 -2.5 l -1.1 -1.5 l -0.4 -0.8 l -3.6 -1.8 l 1.6 -2.3 l -1.9 -1.2 l -1.2 -5.1 l 1.8 0.6 l 1.4 -0.8 l 4.8 0.2 l 2.4 0.5 l 4.2 1 l 10.5 0.1 l 2.3 1 l 1.9 -0.5 l 2 2.3 l 2.7 1.7 l 6.1 1.4 l 1.2 0.6 l 1.3 -7.7 l -0.6 -0.8 l 1.9 -0.1 l 0.4 5.5 l 1.5 -0.1 l 0.1 2.8 l 5.5 -0.4 l 0.1 1 l 0.1 2.1 l -5.5 0.3 l 0.1 2 l 1.3 0.1 l 0.3 1 l -2.7 1.2 l 2 4.9 l 2 1.2 l 1.5 2.6 l 3.4 2.7 l 0.1 1.9 l -8.1 0.3 L 348.9 200.9 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="50%" xlink:href="#Fuxing-Township" text-anchor="middle">福興
        </textPath>
      </text>
      <path id="Puyan-Township" @click="showAlert7" @mouseover="getInfo('Puyan-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 342.8 250.1 l -1.9 -1.4 l -3.8 0.3 l -1.5 0.7 l -1.9 3.4 l 0.6 0.5 l -0.7 11.6 l -0.5 0.9 l -1.9 2.5 l -1.3 1.6 l -1.7 0.4 l -1 1.4 l -3.3 1.4 l -0.2 0.7 l -2.2 -0.9 l -2.4 -3.5 l -3.9 -0.9 l 0.8 6.4 l -2.4 1.8 l -3.8 -7.5 l -2.2 -2.5 l -2 -1.1 l -5.8 -1.3 l -1.9 -0.7 l -1.4 -1 l 0 -1.3 l -1.9 -2.2 l -2.1 -1.3 l -1.8 -2.1 l 0.6 -2.6 l -2.1 -1.8 l -0.5 -2.5 l -2.5 -3 l -2.9 -4.3 l -1.7 -3.7 l -2.1 -3.2 l -0.8 -1.6 l 1.6 0.6 l 5.1 1.1 l 6.8 3.4 l 0.6 -6 l -2 -0.2 l 0.3 -2 l 2 0.2 l 0.6 -5.2 l 2.8 0.2 l 0.9 -4.4 l -3.1 -2.9 l 1.7 -3.7 l 6.6 -5.2 l 0.3 -3.9 l 4 -1.1 l 2.5 -0.3 l 0.6 -2.9 l 1.5 2 l 1.1 1.5 l 1.4 -0.6 l 1.6 0.6 l 1.6 2.6 l 7.6 5 l 5.3 3.6 l 1.5 0.5 l 0.4 0 l 5.3 0 l 3.7 0 l 7 1.3 l 5.9 0.6 l 6.4 2.3 l 1.7 1.3 l 1.3 2.3 l 1.3 5.1 l 3 4.9 l 4.8 4.6 l -2.1 1.1 l 4.4 0.9 l 1.7 1.6 l -0.4 1.4 l -1.7 0.8 l 2.4 3.7 l 1.2 1.6 l 0.8 1.3 l 2.3 1.5 l 0.5 2.7 l -4 0.7 l -2.3 2.1 l -1.7 1.8 l -4.2 0 l -0.5 -1.2 l -2.9 0.3 l 0.2 2 l -4.3 -0.3 l -4 -0.2 l -4.1 -0.4 l 0 -1.3 l -1.9 -3.4 l -4 -0.1 l -0.7 -2.1 l 0 -1 l -1.8 0.2 l -2.2 -2.8 L 342.8 250.1 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="50%" xlink:href="#Puyan-Township" text-anchor="middle">埔鹽
        </textPath>
      </text>
      <path id="Xiushui-Township" @click="showAlert8"  @mouseover="getInfo('Xiushui-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 394.9 222.1 l 0.9 1.1 l -0.1 2.2 l 0.9 1.1 l -0.4 2.9 l -3 0.1 l 0 1.7 l -2.7 0.8 l 0.3 3 l -3.4 0.2 l -1.5 1.1 l 0.4 1.8 l -3.7 1 l -0.8 -1.6 l -3.4 0.9 l -0.9 2 l -2.6 0.7 l -4.4 -0.9 l 2.1 -1.1 l -4.8 -4.6 l -3 -4.9 l -1.3 -5.1 l 1.5 0.4 l -1.3 -3.3 l -1.1 -1.3 l 3.9 -1.5 l -1.7 -1.6 l -1.6 0.7 l 0.3 -1.5 l 1.3 -2.7 l -6.8 -6 l -3.7 -2.1 l -3.4 -2.2 l -1.9 -2.2 l 3.4 -1.4 l 8.1 -0.3 l -0.1 -1.9 l -3.4 -2.7 l -1.5 -2.6 l -2 -1.2 l -2 -4.9 l 2.7 -1.2 l -0.3 -1 l -1.3 -0.1 l -0.1 -2 l 5.5 -0.3 l -0.1 -2.1 l -0.1 -1 l -5.5 0.4 l -0.1 -2.8 l -1.5 0.1 l -0.4 -5.5 l -1.9 0.1 l -1.3 -3.4 l 2.3 -0.8 l 1 -0.6 l -0.1 -11.3 l -2.1 -2.9 L 348 150 l 2.9 0 l 7.6 -2.7 l 1.1 0.4 l 1.9 -3.3 l 0.3 0 l 4.5 -0.4 l 2.4 1.4 l 4 4 l -0.9 1.7 l 1.1 2.6 l 2.8 1.9 l 0 3.2 l 0 3.6 l -2.4 0 l -0.3 1.9 l 1 3 l 1.8 1.4 l 0.3 1.7 l -1.2 1.1 l 1.1 1.7 l 4.1 -4.2 l 3.7 2.7 l 2.9 0.6 l 2.7 6.2 l 0.7 2.5 l 0 6.5 l 0 2.8 l 1 0.5 l -0.7 2.2 l 2.9 3.3 l 0.2 3.3 l 1.3 1.7 l 0.5 2.5 l -1.2 0.7 l 1.5 3.2 l 0.2 2.1 l 2.1 -0.5 l 0.8 1.9 l 2.4 -0.7 l 1.2 2.2 l 2 3.6 l 0.3 1.3 l -6.5 0.8 l 0.7 2.5 l -1 2.3 L 394.9 222.1 Z" />
      <text x="30" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="50%" xlink:href="#Xiushui-Township" text-anchor="middle">秀水
        </textPath>
      </text>
      <path id="Huatan-Township" @click="showAlert9"  @mouseover="getInfo('Huatan-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 412.2 218 l -4.4 -1.6 l -0.7 -0.7 l -2.7 0.8 l -2 -3.6 l -1.2 -2.2 l -2.4 0.7 l -0.8 -1.9 l -2.1 0.5 l -0.2 -2.1 l -1.5 -3.2 l 1.2 -0.7 l -0.5 -2.5 l -1.3 -1.7 l -0.2 -3.3 l -2.9 -3.3 l 0.7 -2.2 l -1 -0.5 l 0 -2.8 l 0 -6.5 l -0.7 -2.5 l -2.7 -6.2 l 1.7 -4.5 l 1.5 2 l 2.5 1.1 l -0.3 0.9 l 7 0.7 l 3.9 0.1 l 1.1 -2.9 l 2.2 0.1 l 9.6 0.5 l 2.9 -0.8 l 1.5 0.8 l 2.1 3.5 l 2.3 -0.1 l 1.2 0.9 l 0.5 1 l 1.9 0 l 3.2 -2.4 l 2.1 -0.6 l 0.7 -1.7 l 3.6 -2.1 l 1.8 0.3 l 1.5 -1.2 l 1.9 0 l 1.1 2.3 l 3.1 0.8 l 0.9 -1.2 l 4 3.1 l 1.2 -0.1 l 0.9 0.2 l 1.5 0.5 l 0.4 1.8 l 2.7 2.8 l -1.2 1.3 l 1 2.2 l 1 0.1 l 3.3 2.8 l 0.9 3.9 l -0.7 3.2 l 2.7 1.8 l 0.8 5 l -0.5 0.9 l 0.3 4 l 1.8 1.5 l 0.4 2.4 l 2.5 4.1 l 0.7 2.2 l 1.4 0.8 l 1.2 2.7 l 2 2.5 l -1.7 -1.7 l -1.4 1.3 l -3.6 1.1 l -1.7 -0.1 l -3.3 -1.8 l -2 1.2 l -1.4 -0.7 l -1.6 2 l -2.3 0.1 l -1.4 -0.9 l -3.7 3.4 l -2.6 1.1 l -3.5 -0.1 l -1 0.9 l -8 1.1 l -9.4 1.3 l -3.3 0.2 l -1.1 -4.4 l -1.3 -1.6 l -4.1 -0.6 l -2.3 0.2 l -2.4 -2 L 412.2 218 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="20%" xlink:href="#Huatan-Township" text-anchor="middle">花壇
        </textPath>
      </text>
      <path id="Fenyuan-Township" @click="showAlert10" @mouseover="getInfo('Fenyuan-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 527.8 221.3 l -4.9 -0.1 l -1.3 0.4 l -3.3 -1.1 l -4.9 1.1 l -1.2 2.7 l -2.3 -1.9 l 0 2 l 0 2.1 l -2.1 6 l 0.2 3.3 l 1.2 2 l 4.3 2.2 l 3.6 2.4 l 4.2 4.3 l 0.8 1.5 l -0.1 1.6 l -3.3 8.5 l -0.5 2.7 l 0.7 1.5 l -0.1 9.2 l -2.6 1.3 l -1.7 4.4 l -6 6.2 L 507 284 l -1.1 -2 l -4.6 -2.2 l 0 -1.8 l -1.3 -1.1 l -2.6 -0.4 l 3 -0.8 l -2 -2.8 l 1.9 0.8 l -0.6 -1.5 l -4 -2.3 l 0.8 -0.5 l -2.7 -3.3 l 0.6 -1.2 l 1.4 0.6 l -1.7 -3.1 l -2.9 -3.3 l 1.3 -0.1 l -1.3 -2 l 0.1 -2.4 l -2.8 -1.9 l 0.2 -1.6 l -1.4 -0.9 l -0.2 -1.7 l -1.4 -0.3 l -0.9 1.1 l -2.7 -4.1 l -0.9 0 l 1.8 2.5 l -0.1 0.9 l -2.1 -2.9 l -1.8 0 l 1.1 -4.1 l 2 -0.4 l -1.7 -1.4 l -0.9 -2.2 l 1.8 0.8 l 0.9 -1.5 l -1.5 -1.1 l 0.1 -2.1 l -3.3 -2.1 l 3.2 0.2 l -0.7 -1.7 l -1.2 -2.2 l -0.8 -1.5 l -2.3 -1.6 l -1.3 -2.9 l 1.8 -1.5 l 0.2 -0.9 l -2 -2.5 l -1.2 -2.7 l -1.4 -0.8 l -0.7 -2.2 l -2.5 -4.1 l -0.4 -2.4 l -1.8 -1.5 l -0.3 -4 l 0.5 -0.9 l -0.8 -5 l -2.7 -1.8 l 0.7 -3.2 l 3.7 -2.1 l 1.8 -0.1 l 4.5 -2.2 l 0 -0.8 l 4.9 -1.2 l 5.7 0.7 l 3.7 -0.4 l 4.3 -2.7 l 3.1 0 l 1.9 -0.8 l 0.2 5.7 l 1.7 1.6 l 0.4 2.1 L 496 193 l -0.3 2.4 l 2 2.1 l 0.5 -0.1 l 2 0.2 l 3.6 -0.8 l 4.1 -0.8 l 1 2.5 l 3.2 1.8 l 1.7 -0.1 l 3 1.6 l 1.4 -0.8 l 0 -1.9 l -1.8 -4.4 l 0.7 -2.2 l 1.5 0.4 l 2.7 3.6 l 2.7 2.4 l 3.8 -2.3 l 5.7 5.6 l 2.3 0.8 l 1.3 1.9 l 3.7 2.9 l 10.4 7.5 l -2.4 3.6 l -3.3 0.7 l -2.4 -0.4 l 3.1 3.2 l -1.2 2.1 L 540 223 l -1.5 -0.9 l -4.8 -0.6 L 527.8 221.3 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="80%" xlink:href="#Fenyuan-Township" text-anchor="middle">芬園
        </textPath>
      </text>
      <path id="Xihu-Township" @click="showAlert11" @mouseover="getInfo('Xihu-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 357.7 261.1 l 4 0.2 l 4.3 0.3 l -0.2 -2 l 2.9 -0.3 l 0.5 1.2 l 4.2 0 l 1.7 -1.8 l 2.3 -2.1 l 4 -0.7 l 2.5 1.9 l -1 1.2 l -2.6 0.9 l -0.7 5.5 l 5 4.2 l 0.1 4.3 l 0.3 3.7 l -1 2.6 l -1.5 -0.2 l -1 4.4 l -0.4 1.7 l 1.1 2.1 l 0.2 4.1 l -0.6 0.8 l -1.5 2.1 l -3.2 6.3 l 0.1 2 l -0.9 -0.2 l -4.4 3.3 l -1.5 0.2 l -0.5 3.6 l -2.4 -1.4 l -2.8 0.6 l -0.9 2.8 l -1.1 -0.1 l 0.6 2.1 l -0.7 1.2 l -3.2 0 l -0.5 4.1 l -5.8 0.2 l -0.7 0.8 l -1.7 -1.2 l -5.9 -0.8 l -1.2 -0.9 l -0.8 0.7 l -7.7 -11.3 l -0.3 0.2 l -1.2 -1.7 l -4.5 -2.5 l -2.8 -2.4 l -3.7 -4.7 l -2.6 -7.6 l -4 -7.8 l -1.7 -2.6 l -0.6 -1.3 l 2.4 -1.8 l -0.8 -6.4 l 3.9 0.9 l 2.4 3.5 l 2.2 0.9 l 0.2 -0.7 l 3.3 -1.4 l 1 -1.4 l 1.7 -0.4 l 1.3 -1.6 l 1.9 -2.5 l 0.5 -0.9 l 0.7 -11.6 l -0.6 -0.5 l 1.9 -3.4 l 1.5 -0.7 l 3.8 -0.3 l 1.9 1.4 l 0.2 0.1 l 2.2 2.8 l 1.8 -0.2 l 0 1 l 0.7 2.1 l 4 0.1 l 1.9 3.4 l 0 1.3 L 357.7 261.1 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="85%" xlink:href="#Xihu-Township" text-anchor="middle">溪湖
        </textPath>
      </text>
      <path id="Dacun-Township" @click="showAlert12" @mouseover="getInfo('Dacun-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 427.8 227.8 l 9.4 -1.3 l 8 -1.1 l 1 -0.9 l 3.5 0.1 l 2.6 -1.1 l 3.7 -3.4 l 1.4 0.9 l 2.3 -0.1 l 1.6 -2 l 1.4 0.7 l 2 -1.2 l 3.3 1.8 l 1.7 0.1 l 3.6 -1.1 l 1.4 -1.3 l 1.7 1.7 l -0.2 0.9 l -1.8 1.5 l 1.3 2.9 l 2.3 1.6 l 0.8 1.5 l 1.2 2.2 l 0.7 1.7 l -3.2 -0.2 l 3.3 2.1 l -0.1 2.1 l 1.5 1.1 l -0.9 1.5 l -1.8 -0.8 l 0.9 2.2 l 1.7 1.4 l -2 0.4 l -4.1 0.1 l -3 3.5 l -3.3 2.2 l -5.3 2.4 l -4.2 3.6 l -1.3 -1 l -4.1 0.7 l -3.9 1 l -4.2 0.5 l 2.6 3.6 l -1 -0.1 l -1.7 -0.2 l -5.8 2 l -0.4 -0.4 l -2 1.2 l -2.8 0.4 l -2.5 0.3 l 0.2 -3.7 l -0.5 -2.6 l 0.5 -2.6 l -6.7 1 l -2.4 1.5 l -3.5 0.6 l -1.4 1.1 l 0.5 1.9 l -1.4 -0.1 l -0.9 -0.7 l -2.3 -1 l -1.6 3 l -3.3 3.1 l -2.8 -0.7 L 404 260 l -1.8 -4.5 l -3.3 0.6 l -3.6 -0.6 l -2.4 0.6 l -5.4 -0.5 l -1.9 0.6 l -3.8 -2.5 l -2.8 -3.1 l -1.1 -0.2 l -1.2 -1.6 l -2.4 -3.7 l 1.7 -0.8 l 0.4 -1.4 l -1.7 -1.6 l 2.6 -0.7 l 0.9 -2 l 3.4 -0.9 l 0.8 1.6 l 3.7 -1 l -0.4 -1.8 l 1.5 -1.1 l 3.4 -0.2 l -0.3 -3 l 2.7 -0.8 l 0 -1.7 l 3 -0.1 l 0.4 -2.9 l -0.9 -1.1 l 0.1 -2.2 l -0.9 -1.1 l 3.1 1.3 l 1 -2.3 l -0.7 -2.5 l 6.5 -0.8 l -0.3 -1.3 l 2.7 -0.8 l 0.7 0.7 l 4.4 1.6 l 1.1 1.7 l 2.4 2 l 2.3 -0.2 l 4.1 0.6 l 1.3 1.6 l 1.1 4.4 L 427.8 227.8 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="0%" xlink:href="#Dacun-Township" text-anchor="middle">大村
        </textPath>
      </text>
      <path id="Puxin-Township" @click="showAlert13" @mouseover="getInfo('Puxin-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 431.2 295.4 l 0.5 4.7 l -2.8 0.6 l -0.7 -0.6 l -3.4 2 l -2.1 2.4 l -0.8 1.1 l -7.7 -0.4 l 0.7 1.7 L 411 308 l -4 1.7 l -1.5 -0.3 l -1.8 -2.2 l -1.3 -4.2 l -0.5 -1.5 l -4.2 -1 l -2.1 0.2 l -0.3 0.6 l -4.1 0.7 l -3 -1.5 l -2.7 2.6 l 3 4.7 l 0.1 2 l -3.3 -2.4 l -1.1 0.7 l -4 1.2 l -0.8 -1.1 l -3.1 -1.2 l 1.5 -1.8 l -0.6 -1.7 l -0.1 -2 l 3.2 -6.3 l 1.5 -2.1 l 0.6 -0.8 l -0.2 -4.1 l -1.1 -2.1 l 0.4 -1.7 l 1 -4.4 l 1.5 0.2 l 1 -2.6 l -0.3 -3.7 l -0.1 -4.3 l -5 -4.2 l 0.7 -5.5 l 2.6 -0.9 l 1 -1.2 l -2.5 -1.9 l -0.5 -2.7 l -2.3 -1.5 l -0.8 -1.3 l 1.1 0.2 l 2.8 3.1 l 3.8 2.5 l 1.9 -0.6 l 5.4 0.5 l 2.4 -0.6 l 3.6 0.6 l 3.3 -0.6 l 1.8 4.5 l 3.2 2.6 l 2.8 0.7 l 3.3 -3.1 l 1.6 -3 l 2.3 1 l -0.2 2.4 l -2 2.5 l -1.2 2.9 l 0.5 3.2 l 2.2 2.5 l 4 1.4 l 7.4 4.1 l 2.2 -0.4 l 1.1 -0.1 l 1.9 1.5 l 0.2 0.3 l 0.1 5.2 l 0.7 1.1 l 2.1 1.4 l -2.8 5.3 l -1.2 -0.5 l -1.1 1 L 431.2 295.4 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="55%" xlink:href="#Puxin-Township" text-anchor="middle">埔心
        </textPath>
      </text>
      <path id="Yuanlin-Township" @click="showAlert14" @mouseover="getInfo('Yuanlin-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 454.5 253.2 l 4.1 -0.7 l 1.3 1 l 4.2 -3.6 l 5.3 -2.4 l 3.3 -2.2 l 3 -3.5 l 4.1 -0.1 l -1.1 4.1 l 1.8 0 l 2.1 2.9 l 0.1 -0.9 l -1.8 -2.5 l 0.9 0 l 2.7 4.1 l 0.9 -1.1 l 1.4 0.3 l 0.2 1.7 l 1.4 0.9 l -0.2 1.6 l 2.8 1.9 l -0.1 2.4 l 1.3 2 l -1.3 0.1 l 2.9 3.3 l 1.7 3.1 l -1.4 -0.6 l -0.6 1.2 l 2.7 3.3 l -0.8 0.5 l 4 2.3 l 0.6 1.5 l -1.9 -0.8 l 2 2.8 l -3 0.8 l 2.6 0.4 l 1.3 1.1 l 0 1.8 l -2.7 -0.4 l 0 0.9 l 6 1.4 l 1.3 2.4 l -2.3 -1.3 l -2.5 1.5 l -1.8 0.1 l 1.4 2.5 l 3.9 4.4 l 1.9 2.4 l -1.3 1 l -2.7 -2.1 l -0.6 1.9 l 2.6 2.1 l 1.2 1.8 l 3.1 2.7 l 0 1.5 l -1.5 -1.3 l -2.6 1.4 l -0.5 2.8 l -2.6 2.2 l -1.3 -0.2 l -4.7 0.6 l -7.4 -2.4 l -1.2 -1.1 l -5.3 -0.2 l -0.7 -0.6 l -2.7 0.9 l -3.2 -0.6 l -1.4 -1.4 l -4.2 1 l 0 0.9 l -4 0.6 l -1.6 0.2 l 0.5 2.7 l -2.1 4.4 l -1.6 2 l -8.7 2 l -2.1 -4.1 l -2.4 -9.6 l -1.6 2.5 L 440 304 l -2.4 0 l -3.2 -2.2 l -0.8 -2.3 l -2 0.6 l -0.5 -4.7 l -0.2 -3.5 l 1.1 -1 l 1.2 0.5 l 2.8 -5.3 l -2.1 -1.4 l -0.7 -1.1 l -0.1 -5.2 l -0.2 -0.3 l -1.9 -1.5 l -1.1 0.1 l -2.2 0.4 l -7.4 -4.1 l -4 -1.4 l -2.2 -2.5 l -0.5 -3.2 l 1.2 -2.9 l 2 -2.5 l 0.2 -2.4 l 0.9 0.7 l 1.4 0.1 l -0.5 -1.9 l 1.4 -1.1 l 3.5 -0.6 l 2.4 -1.5 l 6.7 -1 l -0.5 2.6 l 0.5 2.6 l -0.2 3.7 l 2.5 -0.3 l 2.8 -0.4 l 2 -1.2 l 0.4 0.4 l 5.8 -2 l 1.7 0.2 l 1 0.1 l -2.6 -3.6 l 4.2 -0.5 L 454.5 253.2 Z" />
      <text x="10" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="92%" xlink:href="#Yuanlin-Township" text-anchor="middle">員林
        </textPath>
      </text>
      <path id="Fangyuan-Township" @click="showAlert15" @mouseover="getInfo('Fangyuan-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 169.5 263.7 l 3 -2.9 l 0.7 -2.4 l -0.1 -9.2 l 0.4 -3.9 l 2.3 -1.6 l 1 -1.6 l 4.7 -10.6 l 1.2 -1.9 l 4.8 -4.9 l 4.5 -3.7 l 3.2 -3.1 l 4.3 -2.8 l 2 -4.4 l 1.4 -13.4 l 0.4 -1.6 l 2.6 -4.3 l 1.1 -5 l 0.4 -9.3 l 7.4 2.9 l 11.6 4.1 l 11.1 3.6 l 2.8 0.8 l 3.5 8.8 l 1.9 2.4 l 2.4 1.6 l 0.4 1.2 l 3.6 5.9 l -0.1 2.9 l 2 1.3 l 0 2.7 l 0.7 0.5 l 0.1 2.7 l 2.2 0.4 l -0.7 3.1 l 4.4 2.3 l 1.5 1.4 l 3.7 1.7 l 2.7 -0.5 l 3.4 1.3 l 1.1 2.8 l 2.6 1 l -3.2 8.2 l 1.9 2.4 l -4.3 3.4 l -1.7 3.7 l 1.1 5.1 l -1.4 5.4 l 1.4 2.9 l -0.6 4 l -1.6 3.3 l -0.7 4.7 l 1.4 1.8 l 0.6 0.9 l -3.4 0.2 l -0.4 5.5 l -1.1 -0.1 l -0.1 1.8 l -3.9 -1.2 l -1.5 -1 l -3.4 6.4 l -3.8 0 l -1.4 -1.3 l -0.9 1 l -0.7 6.1 l 0.6 5.6 l -2.2 4.6 l 2.9 -0.2 l 0 1.4 l -1.5 7 l -4.2 1.1 l -1.5 2 l -1.5 -0.3 l -2.8 0.8 l -1.3 -0.4 l -2.4 0.6 l -1.7 2 l -1.8 -1.1 l -0.9 2.6 l 1.7 1 l -1.9 5.1 l -2.3 -0.8 l 0.6 6.1 l 1.4 1.7 l -2.8 1.3 l 0.9 3 l 0.5 3.2 l -1.7 0.3 l -6.7 -0.8 l -0.5 0.9 l 0.3 1.1 l 0.1 2.8 l 0.8 1.5 l -4.9 -1.8 l 0 3.8 l -0.6 0.1 l 1 1.7 l -3.9 9.1 l -0.8 0.4 l -1.9 6.6 l -4.2 -1.1 l -0.3 1.1 l -8.5 -2 l -2.7 1.2 l -1.8 -0.6 l -1.4 1.2 l -1 -1.5 l -5.9 -2 l 1 -3.2 l 1.9 -5.6 l 2.7 0.9 l 0.4 -1 l -5.8 -2 l 0.7 -2.9 l -3.8 -1.3 l -0.3 0.9 l -3 -1 l -1.8 6.6 l -1.2 -0.5 l -3.3 -1.4 l 0.2 -2.8 l -3.5 -1.6 l -3.2 -1 l -0.2 0.7 l -2.6 -1 l -5.7 -3 l -8.6 -5.2 l -7.2 -4.9 l -8.2 -6.2 l -7.3 -6.2 l 0.4 -1.5 l 2.8 -2.3 l 1.5 -2.1 l 2.1 -5 l 1.6 -2 l 0.4 -0.7 l 4.9 -1.6 l 1.5 0 l 3.4 -1.7 l 1 -2.6 l 0.8 -3.7 l 1 -4.7 l -1.1 -2.9 l -0.1 -3.2 l 1.2 -4 l 2.4 -3.7 l 2.2 -1.5 l 4.2 -1.2 l 1.6 -2.5 l 2.8 -3.1 l 4.2 -3.5 L 169.5 263.7 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="0%" xlink:href="#Fangyuan-Township" text-anchor="middle">芳苑
        </textPath>
      </text>
      <path id="Erlin-Township" @click="showAlert16" @mouseover="getInfo('Erlin-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 227.9 341.7 l -0.5 -3.2 l -0.9 -3 l 2.8 -1.3 l -1.4 -1.7 l -0.6 -6.1 l 2.3 0.8 l 1.9 -5.1 l -1.7 -1 l 0.9 -2.6 l 1.8 1.1 l 1.7 -2 l 2.4 -0.6 l 1.3 0.4 l 2.8 -0.8 l 1.5 0.3 l 1.5 -2 l 4.2 -1.1 l 1.5 -7 l 0 -1.4 l -2.9 0.2 l 2.2 -4.6 l -0.6 -5.6 l 0.7 -6.1 l 0.9 -1 l 1.4 1.3 l 3.8 0 l 3.4 -6.4 l 1.5 1 l 3.9 1.2 l 0.1 -1.8 l 1.1 0.1 l 0.4 -5.5 l 3.4 -0.2 L 268 277 l -1.4 -1.8 l 0.7 -4.7 l 1.6 -3.3 l 0.6 -4 l -1.4 -2.9 l 1.4 -5.4 l -1.1 -5.1 l 1.7 -3.7 l 4.3 -3.4 l -1.9 -2.4 l 3.2 -8.2 l 1.4 0.4 l 2.4 2.2 l 2.1 3.2 l 1.7 3.7 l 2.9 4.3 l 2.5 3 l 0.5 2.5 l 2.1 1.8 l -0.6 2.6 l 1.8 2.1 l 2.1 1.3 l 1.9 2.2 l 0 1.3 l 1.4 1 l 1.9 0.7 l 5.8 1.3 l 2 1.1 l 2.2 2.5 l 3.8 7.5 l 0.6 1.3 l 1.7 2.6 l 4 7.8 l 2.6 7.6 l 3.7 4.7 l 2.8 2.4 l 4.5 2.5 l 1.2 1.7 l -7.1 4.7 l -0.8 -2.1 l -4.9 -0.7 l -0.3 -0.5 l -8.3 -0.1 l -0.3 12.8 l 1 0.1 l 1 3.4 l -1.8 7.3 l 1.7 0.2 l -0.4 1 l -3.3 0.2 l 0.1 5.4 l 0.1 2.4 l -2.3 0.5 l -0.4 3.2 l -0.1 3.3 l 2.4 0.5 l 0.9 2.2 l 2.5 0.8 l -1 2.8 l 2.2 3.3 l -0.8 1 l -2.3 0.4 l 1.3 1.2 l 0.7 3.7 l 1.1 1.4 l -0.5 3.7 l -1 1.1 l -1.6 -0.8 l -1.7 1.4 l -1.4 -0.1 l -4.4 -1.8 l -2.4 0.2 l -3.5 -2.8 l -2.2 -1.9 l -2.3 1.3 l -1.9 0.9 l -4.8 -8.1 l -0.4 -0.3 L 280 358 l -1 -5.9 l -2.7 1.6 l -1.8 3.4 l -4 0.2 l -2.4 1.8 l 1.7 3.5 l -0.3 5.1 l -2.1 -0.1 l -0.2 1.3 l 0.1 0.8 l 3.3 1 l -0.9 5.2 l -2.7 0.1 l -0.3 1.1 l 0.1 5.4 l -10.7 0.2 l -0.9 1.3 l -4.5 -0.7 l -0.7 1.5 l -1.9 -0.6 l -0.9 -0.2 l -2.4 -0.7 l -0.3 1 l -4.2 -0.9 l -2.8 0.1 l -1.6 6.6 l -1.4 4.1 l -0.9 -1.6 l -2 2.2 l -2.6 -2.8 l -2.2 -1 l -2.8 2 l -2.9 -1.2 l 0.6 -2.2 l -1.1 -1.9 l -2 0.9 l -1.1 -1 l -2 1.2 l -0.7 -0.6 l -0.7 -1.8 l 1.9 -6.1 l -4.1 -1.3 l 0.3 -0.9 l -5.5 -1.8 l 2.3 -8.8 l 1.9 -6.6 l 0.8 -0.4 l 3.9 -9.1 l -1 -1.7 l 0.6 -0.1 l 0 -3.8 l 4.9 1.8 l -0.8 -1.5 l -0.1 -2.8 l -0.3 -1.1 l 0.5 -0.9 l 6.7 0.8 L 227.9 341.7 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="28%" xlink:href="#Erlin-Township" text-anchor="middle">二林
        </textPath>
      </text>
      <path id="Pitou-Township" @click="showAlert17" @mouseover="getInfo('Pitou-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 355.3 378.5 l -0.8 0.1 l -0.4 5.4 l 0.5 6.9 l 1.9 2.8 l -3.4 1.9 l -2.3 2.3 l -1.9 -1 l 0.2 -5.7 l 1.5 -2.1 l -1.8 -0.2 l -5.2 0.8 l 0.1 7.8 l 0 3.5 l -1.5 1.4 l -2.9 4.7 l -2.3 9.1 l 0.5 0.6 l -3 4 l 0.1 2.3 l -2.2 2.6 l -4.2 -10.2 l -0.8 0.3 l -1.6 -4.5 l -2.8 -0.7 l -2.8 -3.4 l -7.8 -9.2 l -0.2 -2.4 l -0.9 -3.5 l 3.8 -0.7 l -0.4 -1.7 l -0.3 -2.1 l -1.9 -3.4 l 0 -2.6 l -2.7 -4.7 l 0.5 -2.6 l 0.9 -0.6 l -1.3 -3.2 l 1.4 0.1 l 1.7 -1.4 l 1.6 0.8 l 1 -1.1 l 0.5 -3.7 l -1.1 -1.4 l -0.7 -3.7 l -1.3 -1.2 l 2.3 -0.4 l 0.8 -1 l -2.2 -3.3 l 1 -2.8 l -2.5 -0.8 l -0.9 -2.2 l -2.4 -0.5 l 0.1 -3.3 l 0.4 -3.2 l 2.3 -0.5 l -0.1 -2.4 l -0.1 -5.4 l 3.3 -0.2 l 0.4 -1 l -1.7 -0.2 l 1.8 -7.3 l -1 -3.4 l -1 -0.1 l 0.3 -12.8 l 8.3 0.1 l 0.3 0.5 l 4.9 0.7 l 0.8 2.1 l 7.1 -4.7 l 0.3 -0.2 l 7.7 11.3 l 0.8 -0.7 l 0.6 3.3 l -1.7 6.1 l 0.9 2.5 l 2.4 2 l 5 6.7 l 2 1.1 l 5.9 3.3 l 0.2 1.7 l 5.9 1.1 l 1.4 0.3 l 2.6 2.3 l 0.4 2.3 l -1.3 3.4 l 0.6 8.3 l 2.1 2.6 l 0.8 5.4 l 2 1.4 l 2.8 3.3 l 0.1 0.1 l -0.1 1.2 l -2.3 1.3 l -1.2 -0.4 l -1.8 1.6 l -4 0.8 l -4 0.9 l -2.3 0 L 355.3 378.5 Z" />
      <text x="50" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="51%" xlink:href="#Pitou-Township" text-anchor="middle">埤頭
        </textPath>
      </text>
      <path id="Yongjing-Township" @click="showAlert18" @mouseover="getInfo('Yongjing-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 422.6 304.5 l 2.1 -2.4 l 3.4 -2 l 0.7 0.6 l 2.8 -0.6 l 2 -0.6 l 0.8 2.3 l 3.2 2.2 l 2.4 0 l 5.8 1.3 l -1.4 4.2 l -2.1 2 l 0.6 1.8 l 3.9 3.2 l -1.2 1.3 l 1.8 6 l -1.4 -0.1 l 0.6 2.7 l -6 0.5 l -4.1 2.3 l 2.5 6.6 l 0.3 1.3 l -4.7 1.5 l -2.4 0.4 l -5.5 1.1 l 0.7 4.2 l -1 0.1 l -1.4 -8.1 l -1 0.2 l -0.9 -2.4 l -1.8 -0.1 l -1.9 1.1 l -3.2 -0.6 l 0.8 5.9 l -7.1 1.1 l -2.3 -1.1 l 0.7 -6.4 l -2.5 -0.6 l -3.8 -4.1 l -2.8 -1.3 l -3.9 -1 l -1.9 -0.7 l -0.1 1.1 l -2.6 0 l -4.6 -0.7 l -1.4 0.8 l -3.8 -2.3 l -0.9 -0.2 l 0.5 -2.1 l -4.3 -1.3 l -4 -2.7 l -1.5 -2.8 l -1.1 0.3 l -1.8 -2.1 l -2.4 -0.7 l -2 0.6 l -0.6 -2.1 l 1.1 0.1 l 0.9 -2.8 l 2.8 -0.6 l 2.4 1.4 l 0.5 -3.6 l 1.5 -0.2 l 4.4 -3.3 l 0.9 0.2 l 0.6 1.7 l -1.5 1.8 l 3.1 1.2 l 0.8 1.1 l 4 -1.2 l 1.1 -0.7 l 3.3 2.4 l -0.1 -2 l -3 -4.7 l 2.7 -2.6 l 3 1.5 l 4.1 -0.7 l 0.3 -0.6 l 2.1 -0.2 l 4.2 1 l 0.5 1.5 l 1.3 4.2 l 1.8 2.2 l 1.5 0.3 l 4 -1.7 l 3.9 -1.1 l -0.7 -1.7 l 7.7 0.4 L 422.6 304.5 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="80%" xlink:href="#Yongjing-Township" text-anchor="middle">永靖
        </textPath>
      </text>
      <path id="Tianwei-Township" @click="showAlert19" @mouseover="getInfo('Tianwei-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 395.4 327.1 l 3.9 1 l 2.8 1.3 l 3.8 4.1 l 2.5 0.6 l -0.7 6.4 l 2.3 1.1 l 7.1 -1.1 l -0.8 -5.9 l 3.2 0.6 l 1.9 -1.1 l 1.8 0.1 l 0.9 2.4 l 1 -0.2 l 1.4 8.1 l 1 -0.1 l -0.7 -4.2 l 5.5 -1.1 l 2.4 -0.4 l 1.7 10.7 l 2.1 5.8 l 0.6 2 l 1.9 2.7 l -4.5 -1.8 l -3.4 0.2 l -2.9 0 l -0.4 2.3 l 1.1 1.4 l -1.3 0.6 l -1.7 1.1 l -1.3 7.1 l -4.5 -2 l -0.4 3.7 l 1.4 2.2 l 1.6 0.3 l 0.3 1.2 l -6.9 -0.7 l -0.7 -1.6 l -0.4 -6 l -0.5 -1.6 L 415 362 l -2.1 -1.4 l -4.4 -1.5 l -3.5 0.2 l -0.7 0.8 l -3.1 -0.3 l -6 1.9 l -2.1 -0.4 l -2.8 -1.5 l -1.1 -3.9 l -3.5 -1.5 l -0.7 -0.8 l -4.2 -2.3 l -3.8 -1.5 l -4 -0.9 l -2.2 0.2 l -1.8 -1.1 l -2.6 -2.3 l -1.4 -0.3 l -5.9 -1.1 l -0.2 -1.7 l -5.9 -3.3 l -2 -1.1 l -5 -6.7 l -2.4 -2 l -0.9 -2.5 l 1.7 -6.1 l -0.6 -3.3 l 1.2 0.9 l 5.9 0.8 l 1.7 1.2 l 0.7 -0.8 l 5.8 -0.2 l 0.5 -4.1 l 3.2 0 l 0.7 -1.2 l 2 -0.6 l 2.4 0.7 l 1.8 2.1 l 1.1 -0.3 l 1.5 2.8 l 4 2.7 l 4.3 1.3 l -0.5 2.1 l 0.9 0.2 l 3.8 2.3 l 1.4 -0.8 l 4.6 0.7 l 2.6 0 l 0.1 -1.1 L 395.4 327.1 Z" />
      <text x="33" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="88%" xlink:href="#Tianwei-Township" text-anchor="middle">田尾
        </textPath>
      </text>
      <path id="Beidou-Township" @click="showAlert20"  @mouseover="getInfo('Beidou-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 408.5 359.2 l 4.4 1.5 l 2.1 1.4 l 1.6 4.1 l 0.5 1.6 l 0.4 6 l 0.7 1.6 l 6.9 0.7 l -0.3 5.7 l 1.5 0.3 l 5.8 4.6 l 1.1 2.5 l 1.5 -4.8 l 2 3.8 l 4.1 2.6 l 1.4 -0.1 l 1.9 0.6 l 1.8 2.3 l -6.5 7.8 l -2.1 -1.4 l -1.7 1 l -5.4 -0.6 l -1.7 -0.7 l 0.7 1.7 l 3.8 4.5 l -3 2.6 l -3 -2.7 l -3.6 -1.9 l -2.1 -0.2 l -8 -3.7 l -1.3 -2.6 l -3.7 -1.4 l -7.6 -0.4 l 4.3 12.2 l -3.2 -1.8 l -1.9 -2.9 l -1.5 -1.1 l -1.9 -3.2 l -4.1 -4.6 l -1.2 -0.8 l 1.5 -4.1 l -1.5 -2.1 l -3.4 -4.6 l -2.4 -0.4 l -3.9 0.9 l -1.8 -2.2 l 3.4 -4.6 l -3.5 -0.9 l -3.3 -0.5 l -0.1 -0.1 l -2.8 -3.3 l -2 -1.4 l -0.8 -5.4 l -2.1 -2.6 l -0.6 -8.3 l 1.3 -3.4 l -0.4 -2.3 l 1.8 1.1 l 2.2 -0.2 l 4 0.9 l 3.8 1.5 l 4.2 2.3 l 0.7 0.8 l 3.5 1.5 l 1.1 3.9 l 2.8 1.5 l 2.1 0.4 l 6 -1.9 l 3.1 0.3 l 0.7 -0.8 L 408.5 359.2 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="80%" xlink:href="#Beidou-Township" text-anchor="middle">北斗
        </textPath>
      </text>
      <path id="Xizhou-Township" @click="showAlert21"  @mouseover="getInfo('Xizhou-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 355.3 378.5 l 5.3 1.5 l 2.3 0 l 4 -0.9 l 4 -0.8 l 1.8 -1.6 l 1.2 0.4 l 2.3 -1.3 l 0.1 -1.2 l 3.3 0.5 l 3.5 0.9 l -3.4 4.6 l 1.8 2.2 l 3.9 -0.9 l 2.4 0.4 l 3.4 4.6 l 1.5 2.1 l -1.5 4.1 l 1.2 0.8 l 4.1 4.6 l 1.9 3.2 l 1.5 1.1 l 1.9 2.9 l 3.2 1.8 l -4.3 -12.2 l 7.6 0.4 l 3.7 1.4 l 1.3 2.6 l 8 3.7 l 2.1 0.2 l 3.6 1.9 l 3 2.7 l -1.4 1.2 l 4.2 4.9 l 4.5 -3.7 l 5.5 6.8 l 0.7 0.9 l 1.5 -1.2 l 6.3 7.6 l 2.5 -2.1 l 4.8 5.4 l 4.1 3.4 l 4.9 1.1 l 5.7 -1.4 l 0.7 0.6 l -1.1 0.9 l -3.7 4.9 l -3.8 2.5 l -2.4 1 l -2.2 -0.2 l -1.7 1.6 l -1.2 2.4 l -1.5 1.2 l -2.5 2 l -1.3 2.4 l 1.8 6 l 0 4.9 l -5.7 -2.2 l -4.8 -1.2 l -13.3 -2 l -2.1 -1.4 l -7.4 -1.9 l -5.1 -0.4 l -5.4 0.5 l -4.4 -0.3 l -1.9 0.2 l -5.5 2.2 l -1.2 0.1 l -6.7 -0.8 l -9.4 -0.3 l -4.7 -0.8 l -7.9 -2.6 l -1.4 -0.6 l -15.6 -3.3 l -8.1 -2.8 l -12.9 -5.7 l -4.6 -2.2 l -2.8 -0.6 l 0 -7.3 l -0.5 -8.7 l 2.5 -2.5 l 2.1 -0.9 l 0.8 -0.3 l 4.2 10.2 l 2.2 -2.6 l -0.1 -2.3 l 3 -4 l -0.5 -0.6 l 2.3 -9.1 l 2.9 -4.7 l 1.5 -1.4 l 0 -3.5 l -0.1 -7.8 l 5.2 -0.8 l 1.8 0.2 l -1.5 2.1 l -0.2 5.7 l 1.9 1 l 2.3 -2.3 l 3.4 -1.9 l -1.9 -2.8 l -0.5 -6.9 l 0.4 -5.4 L 355.3 378.5 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10" rotate="180">
        <textPath startOffset="50%" xlink:href="#Xizhou-Township" text-anchor="start">州溪
        </textPath>
      </text>
      <path id="Shetou-Township" @click="showAlert22" @mouseover="getInfo('Shetou-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" stroke-miterlimit="10" d="M 445.2 347.5 L 445.2 347.5 l -6.8 7.5 l -2.1 -5.8 l -1.7 -10.7 l 4.7 -1.5 l -0.3 -1.3 l -2.5 -6.6 l 4.1 -2.3 l 6 -0.5 l -0.6 -2.7 l 1.4 0.1 l -1.8 -6 l 1.2 -1.3 l -3.9 -3.2 l -0.6 -1.8 l 2.1 -2 l 1.4 -4.2 l 1.6 -2.5 l 2.4 9.6 l 2.1 4.1 l 8.7 -2 l 1.6 -2 l 2.1 -4.4 l -0.5 -2.7 l 1.6 -0.2 l 4 -0.6 l 0 -0.9 l 4.2 -1 l 1.4 1.4 l 3.2 0.6 l 2.7 -0.9 l 0.7 0.6 l 5.3 0.2 l 1.2 1.1 l 7.4 2.4 l 4.7 -0.6 l 0 1.3 l 2.6 1.3 l 1.7 0.7 l 1.5 2 l 3.1 2.3 l -0.3 1.5 l 0.3 1.5 l -1.9 0.2 l 1.2 2.5 l -1.7 -0.7 l -1.4 0.6 l 1.4 2 l -1.6 2.2 l 1.4 3 l -1.7 -0.8 l 0.5 1.6 l -1.8 2.2 l 1.3 1 l -2.6 1.1 l 3.1 0.5 l -0.1 1.8 l -1.4 -0.4 l 0.1 2.5 l 0.9 0.3 l -1.4 1.6 l 1.9 0.2 l 1.4 1.3 l -1.1 1.8 l 1.3 1.5 l -0.7 2.1 l -1.5 0 l 1.3 1.7 l -1.9 3.6 l 1.7 0.2 l -2.1 2.8 l -2.5 0 l -0.5 4.3 l 0.6 0.9 l -2.1 1.4 l -1.2 4 l 0.3 0.6 l -1.9 2.6 l -3.7 -0.7 l -3.7 -1.8 l -5.1 -1.3 l -7.4 0.5 l -0.4 -1 l -6.9 -0.4 l -1.8 -2.1 l -2.2 0.3 l -1.4 0.4 l -0.2 3.1 l 0.4 3.2 l -7.8 0.2 l -1.5 0.3 l -0.6 0.1 l -1.7 -0.4 l -0.6 0.4 l -1.2 0.8 l -0.4 0.3 l -0.6 -0.6 l -0.4 -0.1 l -0.3 -0.1 l -0.1 0 l -2.5 -2 l -0.1 -0.4 l -0.5 -1.5 l 0 -0.5 l 0 0 l 0.1 -0.2 l 0.6 -0.8 l 0.1 -0.1 l 0.1 -0.2 l 0.1 -0.1 l 0.1 -0.1 l 0.1 -0.2 l 0 0 l 0 -0.1 l 0 0 l 0 -0.1 l -0.8 -2.5 l -0.7 -4.7 l -0.1 -1.9 l 1 -0.9 l -0.9 -2.3 L 445.2 347.5 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="32%" xlink:href="#Shetou-Township" text-anchor="middle">社頭
        </textPath>
      </text>
      <path id="Tianzhong-Township" @click="showAlert23" @mouseover="getInfo('Tianzhong-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 496.3 368.1 l 1 2 l -0.7 3.5 l -1.3 0.7 l 0.2 2.8 l -2.5 -1 l -1.7 1.6 l 0.7 0.5 l -0.1 3.2 l 0.1 1.5 l 1.4 0.2 l 1.6 1.8 l -0.5 1.7 l 1.9 2.2 l 1.6 -0.1 l 0.2 1.2 l 1.2 0 l -1.8 1.9 l -0.1 4.1 l -3 2.5 l -0.3 1.2 l -3.3 -1.1 l 0.1 1.1 l 4.1 1.3 l -2.1 1.1 l -0.3 2.2 l -3 0.3 l 1.3 1 l -1.4 1 l 0.6 1 l -3.4 1.2 l -3.2 1.9 l -2 0.4 l -1.6 1.6 l -2.6 1.2 l -0.9 1.4 l -2.7 -3.4 l -2.6 0.5 l -3.5 -0.2 l -1.7 -1.7 l 1.1 2.4 l 1.9 2.4 l -0.3 4.3 l 1.7 0.4 l 0.6 5.4 l 1.3 0.2 l 0.4 2.7 l 2.1 3.5 l -1.1 0.2 l -0.7 -0.6 l -5.7 1.4 l -4.9 -1.1 l -4.1 -3.4 l -4.8 -5.4 l -2.5 2.1 l -6.3 -7.6 l -1.5 1.2 l -0.7 -0.9 l -5.5 -6.8 l -4.5 3.7 l -4.2 -4.9 l 1.4 -1.2 l 3 -2.6 l -3.8 -4.5 l -0.7 -1.7 l 1.7 0.7 l 5.4 0.6 l 1.7 -1 l 2.1 1.4 l 6.5 -7.8 l -1.8 -2.3 l -1.9 -0.6 l -1.4 0.1 l -4.1 -2.6 l -2 -3.8 l -1.5 4.8 l -1.1 -2.5 l -5.8 -4.6 l -1.5 -0.3 l 0.3 -5.7 l -0.3 -1.2 l -1.6 -0.3 l -1.4 -2.2 l 0.4 -3.7 l 4.5 2 l 1.3 -7.1 l 1.7 -1.1 l 1.3 -0.6 l -1.1 -1.4 l 0.4 -2.3 l 2.9 0 l 3.4 -0.2 l 4.5 1.8 L 439 357 l -0.6 -2 l 6.8 -7.5 l 0 0 l -0.3 2.9 l 0.9 2.3 l -1 0.9 l 0.1 1.9 l 0.7 4.7 l 0.8 2.5 l 0 0.1 l 0 0 l 0 0.1 l 0 0 l -0.1 0.2 l -0.1 0.1 l -0.1 0.1 l -0.1 0.2 l -0.1 0.1 l -0.6 0.8 l -0.1 0.2 l 0 0 l 0 0.5 l 0.5 1.5 l 0.1 0.4 l 2.5 2 l 0.1 0 l 0.3 0.1 l 0.4 0.1 l 0.6 0.6 l 0.3 -0.2 l 0.1 -0.1 l 1.2 -0.8 l 0.6 -0.4 l 1.7 0.4 l 0.6 -0.1 l 1.5 -0.3 l 7.8 -0.2 l -0.4 -3.2 l 0.2 -3.1 l 1.4 -0.4 l 2.2 -0.3 l 1.8 2.1 l 6.9 0.4 l 0.4 1 l 7.4 -0.5 l 5.1 1.3 l 3.7 1.8 L 496.3 368.1 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="86%" xlink:href="#Tianzhong-Township" text-anchor="middle">田中
        </textPath>
      </text>
      <path id="Ershui-Township" @click="showAlert24" @mouseover="getInfo('Ershui-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 522.7 439.8 l 1.3 0.4 l 4.3 -0.8 l 2.5 -1.5 l 3.9 -0.9 l 2.7 0.4 l -0.3 -1.4 l 2.9 -0.3 l 2.4 -2.1 l 4.7 -1.7 l 1.9 0.8 l 2.5 3.3 l -0.9 2.5 l 0.5 3.3 l -0.1 3.1 l 0.6 2.7 l 3.6 -0.1 l 0.9 0.7 l 0.5 4.5 l -4.1 -0.3 l -4.9 2 l -5.6 4.1 l -3.1 2.8 l -4.3 2.1 l -4.3 0.8 l -10.2 3.8 l -3.5 1 l -2.2 1.2 l -7.7 -1.1 l -1.9 -2.4 l -2.5 -0.8 l -12.9 -1.3 l -2.8 -0.6 l -5.3 0.1 l -18 0.1 l -6 -1 l -3.1 -1.4 l 0 -4.9 l -1.8 -6 l 1.3 -2.4 l 2.5 -2 l 1.5 -1.2 l 1.2 -2.4 l 1.7 -1.6 l 2.2 0.2 l 2.4 -1 l 3.8 -2.5 l 3.7 -4.9 l 1.1 -0.9 l 1.1 -0.2 l -2.1 -3.5 l -0.4 -2.7 l -1.3 -0.2 l -0.6 -5.4 l -1.7 -0.4 l 0.3 -4.3 l -1.9 -2.4 l -1.1 -2.4 l 1.7 1.7 l 3.5 0.2 l 2.6 -0.5 l 2.7 3.4 l 0.9 -1.4 l 2.6 -1.2 l 1.6 -1.6 l 2 -0.4 l 3.2 -1.9 l 0.8 1.3 l 2 0.5 l 0.3 -1.7 l 2.6 -1.4 l 1 1 l -1.3 1.6 l 3.2 -0.3 l 2.1 -2.5 l 0.3 1.6 l 2.1 2.9 l -2.9 0.3 l -0.7 0.9 l 5.4 -0.3 l -1.9 1.4 l 2.9 0.2 l -0.9 1.1 l 3.5 0.3 l -0.1 0.6 l -4.8 1.9 l -3.9 0.3 l -2 1.8 l 0.8 1 l 3.8 -2.2 l 3.1 -1.3 l -0.1 1.4 l 2.9 -1.9 l 3.8 0 l 1.5 1.6 l -2.4 -0.3 l 2.2 3 l -2.2 1.2 l 3.5 0.5 l -1.8 1.2 l 2.2 1.5 l -2.9 -0.9 l -0.1 1.2 l 2.3 0.3 l -1.4 0.9 l 2.7 2.7 l -0.3 0.6 l 3.8 2.9 l 5 2.4 L 522.7 439.8 Z" />
      <text x="68" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="80%" xlink:href="#Ershui-Township" text-anchor="middle">二水
        </textPath>
      </text>
      <path id="Dacheng-Township" @click="showAlert25" @mouseover="getInfo('Dacheng-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 173.7 431.4 l -0.7 0 l -14.9 -4.3 l -6.2 -1.7 l -21.9 -6.2 l -11.2 -3.4 l -6 -3.6 l -3.5 -2.7 l -6 -5.2 l -4 -4 l -5.1 -5.8 l -3.5 -4.4 l -7.3 -10 l 4 -4.6 l 1.9 -4.3 l -0.3 -1.8 l 1 -2.2 l 3.9 -3.1 l 2.8 -3.3 l 1.9 -2 l 3.1 -2.2 l 2.3 -0.8 l 6.6 -0.6 l 3.4 -2.6 l 1.7 -1 l 3.1 -2.8 l 2.6 -5.7 l -2.2 -4.5 l 0.6 -5 l 2.5 -3.6 l 2.2 -4.4 l -0.3 -3.7 l 7.3 6.2 l 8.2 6.2 l 7.2 4.9 l 8.6 5.2 l 5.7 3 l 2.6 1 l 0.2 -0.7 l 3.2 1 l 3.5 1.6 l -0.2 2.8 l 3.3 1.4 l 1.2 0.5 l 1.8 -6.6 l 3 1 l 0.3 -0.9 l 3.8 1.3 l -0.7 2.9 l 5.8 2 l -0.4 1 l -2.7 -0.9 l -1.9 5.6 l -1 3.2 l 5.9 2 l 1 1.5 l 1.4 -1.2 l 1.8 0.6 l 2.7 -1.2 l 8.5 2 l 0.3 -1.1 l 4.2 1.1 l -2.3 8.8 l 5.5 1.8 l -0.3 0.9 l 4.1 1.3 l -1.9 6.1 l 0.7 1.8 l 0.7 0.6 l 2 -1.2 l 1.1 1 l 2 -0.9 l 1.1 1.9 l -0.6 2.2 l 2.9 1.2 l 2.8 -2 l 2.2 1 l 2.6 2.8 l 1.1 1.7 l -1 4.9 l 4.6 2.9 l 8 -0.1 L 244 407 l -7.1 2.4 l 4.6 12.7 l -4.9 0.1 l -10.4 5.9 l -7.9 1 l -13.8 0.1 l -5.8 -0.1 l -17.1 2.5 L 173.7 431.4 Z" />
      <text x="32" y="50" text-anchor="middle" fill="black" font-size="10">
        <textPath startOffset="20%" xlink:href="#Dacheng-Township" text-anchor="middle">大城
        </textPath>
      </text>
      <path id="Zhutang-Township" @click="showAlert26" @mouseover="getInfo('Zhutang-Township')" fill="#ffffff" pointer-events="initial" stroke="#000000" d="M 299.5 366.4 l 3.5 2.8 l 2.4 -0.2 l 4.4 1.8 l 1.3 3.2 l -0.9 0.6 l -0.5 2.6 l 2.7 4.7 l 0 2.6 l 1.9 3.4 l 0.3 2.1 l 0.4 1.7 l -3.8 0.7 l 0.9 3.5 l 0.2 2.4 l 7.8 9.2 l 2.8 3.4 l 2.8 0.7 l 1.6 4.5 l -2.1 0.9 l -2.5 2.5 l 0.5 8.7 l 0 7.3 l -3.4 -0.7 l -1.3 -1.5 l -3.5 -2.3 l -3.3 -1.6 l -3.1 -3.2 l -1.4 -2 l -6.6 -3.7 l -8.3 0 l -7.2 3.7 l -1.8 0.1 l -6 0.5 l -7.5 -0.7 l -14.4 -1.2 l -7.3 -0.6 l -6.7 -0.1 l -4.6 -12.7 l 7.1 -2.4 l 0.2 -2.8 l -8 0.1 l -4.6 -2.9 l 1 -4.9 l -1.1 -1.7 l 2 -2.2 l 0.9 1.6 l 1.4 -4.1 l 1.6 -6.6 l 2.8 -0.1 l 4.2 0.9 l 0.3 -1 l 2.4 0.7 l 0.9 0.2 l 1.9 0.6 l 0.7 -1.5 l 4.5 0.7 l 0.9 -1.3 l 10.7 -0.2 l -0.1 -5.4 l 0.3 -1.1 l 2.7 -0.1 l 0.9 -5.2 l -3.3 -1 l -0.1 -0.8 l 0.2 -1.3 l 2.1 0.1 l 0.3 -5.1 l -1.7 -3.5 l 2.4 -1.8 l 4 -0.2 l 1.8 -3.4 l 2.7 -1.6 l 1 5.9 l 7.9 0.2 l 0.4 0.3 l 4.8 8.1 l 1.9 -0.9 l 2.3 -1.3 L 299.5 366.4 Z" />
      <text x="40" y="50" text-anchor="middle" fill="black" font-size="10" rotate="180">
        <textPath startOffset="29%" xlink:href="#Zhutang-Township" text-anchor="middle">塘竹
        </textPath>
      </text>
    </svg>
    </div>
  </div>
</template>
<style>
@media(max-width:576px){
  .container_location{
    padding-top: 10rem;
    padding-bottom: 2rem;
    margin: auto;
    width: 80%;
  }
}
@media (min-width: 578px) and (max-width: 768px) {
  .container_location{
    padding-top: 10rem;
    padding-bottom: 5rem;
    margin: auto;
    width: 80%;
  }
}
@media(min-width:768px){
  .container_location{
    padding-top: 20rem;
    padding-bottom: 5rem;
    margin: auto;
    max-width: 80%;
  }
}
#location{
  background-color:rgba(65, 53, 77,0.5);
}
#location text{
  fill:rgb(65, 53, 77);
}
#location path{
    fill:transparent;
    stroke: rgb(255, 209, 149);
    stroke-width: 0.8px;
    transition: 0.5s;
    cursor: pointer;
}

#location path:hover{
    fill:rgba(222, 126, 68,0.2);
}

.subtitle h5{
    margin: 0;
  }

.img_oldhouse{
  width: 100%;
}
.swal2-content img{
  width:300px;
  height:200px;
}

</style>
<script>

export default {
  data () {
    return {
      showdata: {},
      place_data: [
        {
          tag: 'Shengang-Township',
          chinese_name: '伸港鄉',
          english_name: 'Shengang Township',
          old_house: 2
        },
        {
          tag: 'Xianxi-Township',
          chinese_name: '線西鄉 ',
          english_name: 'Xianxi Township',
          old_house: 5
        },
        {
          tag: 'Hemei-Township',
          chinese_name: '和美鎮',
          english_name: 'Hemei Township',
          old_house: 6
        },
        {
          tag: 'Zhanghua-City',
          chinese_name: '彰化市 ',
          english_name: 'Zhanghua City',
          old_house: 10
        },
        {
          tag: 'Lugang-Township',
          chinese_name: '鹿港鎮',
          english_name: 'Lugang Township',
          old_house: 11
        },
        {
          tag: 'Fuxing-Township',
          chinese_name: '福興鄉',
          english_name: 'Fuxing Township',
          old_house: 1
        },
        {
          tag: 'Puyan-Township',
          chinese_name: '埔鹽鄉',
          english_name: 'Puyan Township',
          old_house: 2
        },
        {
          tag: 'Xiushui-Township',
          chinese_name: '秀水鄉 ',
          english_name: 'Xiushui Township',
          old_house: 2
        },
        {
          tag: 'Huatan-Township',
          chinese_name: '花壇鄉',
          english_name: 'Huatan Township',
          old_house: 2
        },
        {
          tag: 'Fenyuan-Township',
          chinese_name: '芬園鄉',
          english_name: 'Fenyuan Township',
          old_house: 2
        },
        {
          tag: 'Xihu-Township',
          chinese_name: '溪湖鎮',
          english_name: 'Xihu Township',
          old_house: 2
        },
        {
          tag: 'Dacun-Township',
          chinese_name: '大村鄉',
          english_name: 'Dacun Township',
          old_house: 2
        },
        {
          tag: 'Puxin-Township',
          chinese_name: '埔心鄉',
          english_name: 'Puxin Township',
          old_house: 2
        },
        {
          tag: 'Yuanlin-Township',
          chinese_name: '員林鎮',
          english_name: 'Yuanlin Township',
          old_house: 2
        },
        {
          tag: 'Fangyuan-Township',
          chinese_name: '芳苑鄉',
          english_name: 'Fangyuan Township',
          old_house: 2
        },
        {
          tag: 'Erlin-Township',
          chinese_name: '二林鎮',
          english_name: 'Erlin Township',
          old_house: 2
        },
        {
          tag: 'Pitou-Township',
          chinese_name: '埤頭鄉',
          english_name: 'Pitou Township',
          old_house: 2
        },
        {
          tag: 'Yongjing-Township',
          chinese_name: '永靖鄉',
          english_name: 'Yongjing Township',
          old_house: 2
        },
        {
          tag: 'Tianwei-Township',
          chinese_name: '田尾鄉',
          english_name: 'Tianwei Township',
          old_house: 2
        },
        {
          tag: 'Beidou-Township',
          chinese_name: '北斗鎮',
          english_name: 'Beidou Township',
          old_house: 2
        },
        {
          tag: 'Xizhou-Township',
          chinese_name: '溪州鄉',
          english_name: 'Xizhou Township',
          old_house: 2
        },
        {
          tag: 'Tianzhong-Township',
          chinese_name: '田中鎮',
          english_name: 'Tianzhong Township',
          old_house: 2
        },
        {
          tag: 'Ershui-Township',
          chinese_name: '二水鄉',
          english_name: 'Ershui Township',
          old_house: 2
        },
        {
          tag: 'Dacheng-Township',
          chinese_name: '大城鄉',
          english_name: 'Dacheng Township',
          old_house: 2
        },
        {
          tag: 'Zhutang-Township',
          chinese_name: '竹塘鄉',
          english_name: 'Zhutang Township',
          old_house: 2
        }
      ]
    }
  },
  methods: {
    getInfo (name) {
      this.showdata = this.place_data.filter(place => {
        return place.tag === name
      })[0]
    },
    showAlert1 () {
      this.$swal({
        title: '伸港鎮',
        html: '<span>伸港鄉（臺灣話：Sin-káng-hiong；古名塗葛堀港、新港）位於臺灣彰化縣最北端，西臨臺灣海峽，北、東北隔大肚溪與臺中市龍井區、大肚區相望，東鄰和美鎮，南鄰線西鄉。人口密度高達1,683人/km²，為全國人口密度第三高的鄉，僅次於屏東縣琉球鄉以及與本鄉同縣的永靖鄉[1]；同時也是彰化縣唯二人口正成長的行政區，另一個是大村鄉。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert2 () {
      this.$swal({
        title: '線西鄉',
        html: '<span>線西鄉是臺灣彰化縣下轄的一個鄉，位於彰化縣西北部，北鄰伸港鄉，東接和美鎮，南臨鹿港鎮，西濱臺灣海峽。面積大約18平方公里，是彰化縣面積最小的行政區，產業以漁業、農業為主，彰化縣最大工業區彰化濱海工業區之線西區與崙尾區即位於該鄉西南方。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert3 () {
      this.$swal({
        title: '和美鎮',
        html: '<span>和美鎮位於臺灣彰化縣西北方，為彰化市的衛星城市，北臨大肚溪與臺中市大肚區相望，西北鄰伸港鄉、線西鄉，西南鄰鹿港鎮、秀水鄉，東鄰彰化市。氣候屬副熱帶季風氣候，年均溫約23℃，全年雨量大多分布在2月至9月，多寡比率依序為梅雨、颱風雨或西南氣流降雨，最後是春雨，冬季時東北季風風力強勁。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert4 () {
      this.$swal({
        title: '彰化市',
        html: '<span>彰化市位於臺灣彰化縣東北角，為彰化縣縣治所在地。市內人口約23.2萬人，為彰化縣人口最多的行政區，亦為中台灣人口第二大城，自桃園縣桃園市於2014年12月升格改制為桃園市桃園區後，目前為全國人口最多的縣轄市，亦為全國人口第二密集的縣轄市。</span> ' + '<br>' + '<br>' + '<img src="https://raw.githubusercontent.com/vina2325/img/master/1.jpg"><p>2/1 room</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/2.jpg"><p>棲身habitat</p>' + '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/6.jpg"><p>半線屋</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/7.jpg"><p>咖啡 烟</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/8.jpg"><p>品 . 茗茶丘好</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert5 () {
      this.$swal({
        title: '鹿港鎮',
        html: '<span>鹿港鎮，舊稱「鹿仔港」，臺灣第一個由漢人移民建立的都會，曾是清代台灣經濟貿易中心，故鹿港俗諺云：「頂到通霄，南到瑯嶠。」</span> ' + '<br>' + '<br>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/5.jpg"><p>小艾謙和人文民宿</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/9.jpg"><p>泰豐號</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/10.jpg"><p>茉莉東聯合辦公室</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert6 () {
      this.$swal({
        title: '福興鄉',
        html: '<span>福興鄉位於臺灣彰化縣西部，西濱臺灣海峽，北鄰鹿港鎮，東連秀水鄉，南接埔鹽鄉、二林鎮、芳苑鄉。境內人口約4.66萬人，為全國人口第十大鄉，其人口數為彰化縣18個鄉之中最多者，亦是中台灣地區人口數僅次於雲林縣麥寮鄉第二多的鄉。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert7 () {
      this.$swal({
        title: '埔鹽鄉',
        html: '<span>埔鹽鄉位於台灣彰化縣中部。東邊及北邊沿台灣溝與大村鄉、秀水鄉及福興鄉相鄰，西南邊隔舊濁水溪與二林鎮相鄰，南邊與溪湖鎮相鄰。 埔鹽鄉還未開發之前是一片滿目荒野的草原地，為平埔原住民族「巴布薩族」馬芝遴社的居住地區，約在三百多年前，先民由福建泉州來到本鄉拓墾，只見當時地面被耐鹽分植物「蒲鹽菁」所覆蓋。 </span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert8 () {
      this.$swal({
        title: '秀水鄉',
        html: '<span>秀水鄉位於台灣彰化縣中部，地理環境東西狹南北長，屬狹長型態，地勢平坦，有濁水溪流域灌溉，水質清澈，醞釀了酪農故鄉的環境。地處於彰化市之南，東鄰花壇鄉，西接鹿港鎮、福興鄉，南連大村鄉及埔鹽鄉，北接和美鎮與彰化市，為典型的純樸農村，其人口密度約為1,330人/km²，為全國人口密度第六高的鄉。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert9 () {
      this.$swal({
        title: '花壇鄉',
        html: '<span>花壇鄉位於臺灣彰化縣北部，比鄰縣治彰化市，東側隔八卦台地與芬園鄉隔山相接，南鄰大村鄉，西毗秀水鄉，北臨彰化市。人口密度為1,251人/km²，為全國人口第八密集的鄉。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert10 () {
      this.$swal({
        title: '芬園鄉',
        html: '<span>芬園鄉位於臺灣彰化縣東北部，地處彰化縣、臺中市、南投縣三縣市之交界。因西側緊鄰八卦山山脈，使本鄉成為全縣26鄉鎮中唯一位居八卦山東麓的鄉治。受到地形的影響，本鄉與臺中市、南投縣的地緣及生活關係反而較為密切。芬園一名源於清領時期當地居民種植罌粟菸草，臺語稱菸草為「芬」或「薰」，當時取其近音「芬」字，因而名為「芬園」。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert11 () {
      this.$swal({
        title: '溪湖鎮',
        html: '<span>溪湖鎮位於台灣彰化縣的地理中心，北為埔鹽鄉，西為二林鎮，南為埤頭鄉、田尾鄉、永靖鄉，東為埔心鄉。南北向有中山高速公路與省道台19線縱貫，東西向有縣道148號、縣道146號橫貫，交通便利。由於腹地廣大，土壤肥沃，為全台最重要的蔬菜產地及集散市場之一，其中尤其以韭菜花最負盛名 。另外葡萄和羊肉爐也是溪湖的特產。</span> ' + '<br>' + '<br>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/11.jpg"><p>為新醫院X糖廠製造</p>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/12.jpg"><p>滴答咖啡</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert12 () {
      this.$swal({
        title: '大村鄉',
        html: '<span>大村鄉位於臺灣彰化縣中部偏東北，行政區域輪廓東西寬、南北窄，北臨花壇鄉，南毗員林市、埔心鄉，東接芬園鄉，西端接埔鹽鄉，西北傍秀水鄉，為彰化都會區的南緣，產業上以第一級產為主、第三級產業為輔，為巨峰葡萄著名的產地之一。</span> ' + '<br>' + '<br>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/3.jpg"><p>大路畔柑仔店</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert13 () {
      this.$swal({
        title: '埔心鄉',
        html: '<span>埔心鄉位於臺灣彰化縣中部，北臨大村鄉，西鄰溪湖鎮，東鄰員林市，南接永靖鄉。全鄉地勢平坦，屬彰化平原的一部份，人口3.4萬人，近年來隨著員林市都市範圍擴張，本鄉也逐漸成為員林市的衛星城市。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert14 () {
      this.$swal({
        title: '員林鎮',
        html: '<span>員林市位於臺灣彰化縣中部偏東位置，是南彰化經濟、文化中心，建城於1728年。2015年8月8日由員林鎮改制為縣轄市員林市，成為彰化縣第二個縣轄市。在員林鎮時期，因多次成為臺灣人口最多的鎮，故有「全臺第一大鎮」美稱。現人口數約12.5萬人，是彰化縣人口第二多行政區，也是全國人口第四多縣轄市。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert15 () {
      this.$swal({
        title: '芳苑鄉',
        html: '<span>芳苑鄉位於臺灣彰化縣西南隅，西濱台灣海峽，屬濁水溪沖積扇下游平原一部分，地勢低平，氣候屬副熱帶季風氣候，年雨量僅約1,000~1,200公釐，炎熱乾燥。面積大約91.3平方公里，為彰化縣面積次大的行政區；人口密度約360人/km²，居全縣倒數第三。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert16 () {
      this.$swal({
        title: '二林鎮',
        html: '<span>二林鎮位於臺灣彰化縣西南部，地當舊濁水溪下游與魚寮溪之間之濁水溪沖積扇上，東接埤頭鄉，西連芳苑鄉、南鄰大城鄉，北隔舊濁水溪連接溪湖、埔鹽二鄉鎮。全鎮略呈橢圓型，地勢平坦，土壤肥沃，為一典型農業鄉鎮，亦是全縣面積最大的行政區。古時為巴布薩族二林社所在之地。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert17 () {
      this.$swal({
        title: '埤頭鄉',
        html: '<span>埤頭鄉，是位於台灣彰化縣中部偏南的一個鄉，北端接溪湖鎮，東北鄰田尾鄉，東鄰北斗鎮，東南鄰溪州鄉，西南鄰竹塘鄉，西與西北接二林鎮。 地處濁水溪沖積扇，地勢較為平坦，產業以農業為主，境內設有明道大學。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert18 () {
      this.$swal({
        title: '永靖鄉',
        html: '<span>永靖鄉位於台灣彰化縣中部偏東南，北、東北鄰埔心鄉、員林市，東鄰社頭鄉，南鄰田尾鄉，西鄰溪湖鎮。鄉內地勢平坦，無山嶽、湖澤，人口密度約1,770人/km²，為臺灣本島人口密度最高的鄉，亦為全國人口密度次高的鄉。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert19 () {
      this.$swal({
        title: '田尾鄉',
        html: '<span>田尾鄉位於台灣彰化縣南部，為東西狹長農村，縱貫公路從中間通過，北緣永靖鄉、南接北斗鎮，以公路花園著名，為花卉生產專業區，1973年成立開闢公路花園園藝觀光區，以民生路與民族路沿路為主要觀光路線，田尾的花卉年產量與種類居全臺灣之冠，有花鄉之稱。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert20 () {
      this.$swal({
        title: '北斗鎮',
        html: '<span>北斗鎮位於臺灣彰化縣東南部，東螺溪北岸，在清領時期曾是中臺灣之重要河港與貨物集散地，經溪湖、鹿港可與福建從事貿易。然而日治時期以後，因東螺溪失去濁水溪下游主流地位且溪流淤積，後興築鐵路時又未經過本地，交通樞紐地位漸被員林所取代，目前為彰化縣下轄六個鎮之中人口最少者。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert21 () {
      this.$swal({
        title: '溪州鄉',
        html: '<span>溪州鄉位於臺灣彰化縣最南端，南隔濁水溪與雲林縣相望，位居濁水溪沖積扇之上，地勢低平。面積居全縣第三大，約有75.8平方公里。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert23 () {
      this.$swal({
        title: '田中鎮',
        html: '<span>田中鎮位於臺灣彰化縣東南方，以前此地是一片水田，舊名田中央，日治時期改名為田中。彰化縣內有八個分區，其中一個就是以田中鎮為中心的田中分區，包含了田中鎮、社頭鄉、二水鄉三地。</span> ' + '<br>' + '<br>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/4.jpg"><p>女人香臭豆腐</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert22 () {
      this.$swal({
        title: '社頭鄉',
        html: '<span>社頭鄉位於中華民國臺灣省彰化縣東南部。據耆老相傳，在明末清初，漢人移居臺灣，稱番人聚落為「社」，「社頭」地名蓋因洪雅族大武郡社之頭首或頭人居住於此，以之得名。 目前以蕭姓為鄉內最大宗，古時候，常以同血緣關係而形成部落，故彰化地區流傳著「鹿港施一半，社頭蕭了了」。 </span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert24 () {
      this.$swal({
        title: '二水鄉',
        html: '<span>二水鄉位於臺灣彰化縣東南隅，為彰化縣人口最少的行政區，地處濁水溪沖積扇的最東端，東北枕八卦台地，南臨濁水溪，其扇頂鼻仔頭便位居鄉內東境，是一個典型的農業鄉。 鄉治所在地的二水車站是臺鐵縱貫線與集集線的交會點。 </span> ' + '<br>' + '<br>' +
        '<img src="https://raw.githubusercontent.com/vina2325/LightUpOldHouse/master/src/assets/card/13.jpg"><p>齊造園</p>',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert25 () {
      this.$swal({
        title: '大城鄉',
        html: '<span>大城鄉位於台灣彰化縣西南端，位居濁水溪沖積扇最下游端，地勢平坦，東為竹塘鄉，西濱台灣海峽，南隔濁水溪口與雲林縣相望，北鄰芳苑鄉與二林鎮，為彰化縣人口密度最低的行政區。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    },
    showAlert26 () {
      this.$swal({
        title: '竹塘鄉',
        html: '<span>竹塘鄉位於臺灣彰化縣西南部，北鄰二林鎮，東北鄰埤頭鄉，東南端接溪州鄉，南邊東段、南邊隔濁水溪分別與雲林縣西螺鎮、二崙鄉相望，西南端接大城鄉；地處濁水溪沖積扇之上，地勢低平。 「竹塘」一名由當地先民開發前的景觀而得名，雖已不復當時蘆竹叢生、窪地水塘遍布之景象，但竹塘的名字卻是道地古時候的自然生態寫照。</span> ',
        footer: '彰化老屋據點',
        showCloseButton: true,
        showConfirmButton: false,
        backdrop: `
        rgba(65, 53, 77,0.9)
        url("https://raw.githubusercontent.com/vina2325/img/master/light2.gif")
        left bottom
        no-repeat
        `
      })
    }
  }
}
</script>
